import { useState, useEffect } from 'react';
import { ArrowRight, CheckCircle2, Rocket } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const localImagesGlob = import.meta.glob('@/assets/carousel/*.{png,jpg,jpeg,webp}', { eager: true });
const localImages = Object.values(localImagesGlob).map((img: any) => img.default);

const carouselImages = localImages.length > 0 ? localImages : [
  "https://letswatch.com.br/images/1.png",
  "https://letswatch.com.br/images/2.png",
  "https://letswatch.com.br/images/3.png",
  "https://letswatch.com.br/images/4.png",
  "https://letswatch.com.br/images/5.png"
];

export const LandingHero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % carouselImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const handleStartFree = () => {
    if (user) {
      // Se usuario logado, redireciona para dashboard
      navigate('/dashboard');
    } else {
      // Se nao logado, vai para auth com aba de cadastro
      navigate('/auth?signup=true');
    }
  };



  return (
    <section className="relative pt-24 lg:pt-32 min-h-screen lg:min-h-0 flex items-center overflow-hidden bg-white">
      <div className="max-w-[1440px] mx-auto w-full px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">

          {/* Content Side */}
          <div className="w-full lg:w-1/2 py-8 lg:py-24 animate-fade-in">
            <div className="flex items-center gap-2 mb-4">
              <Rocket className="w-5 h-5 text-green-600" />
              <span className="text-gray-600 font-bold text-sm tracking-wide">Plataforma de Digital Signage Inteligente</span>
            </div>
            <div className="inline-block bg-primary/10 text-primary px-4 py-1.5 rounded-full text-[10px] lg:text-xs font-black uppercase tracking-[0.2em] mb-6">
              #1 IDOOH | Interactive Digital Out of Home
            </div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-black tracking-tight leading-[0.95] mb-8 lg:mb-10 text-gray-900">
              Transforme suas TV's em{' '}
              <span className="text-primary bg-gradient-to-r from-green-600 to-green-500 bg-clip-text text-transparent">
                ativos digitais.
              </span>
            </h1>

            <p className="text-lg lg:text-2xl text-gray-600 mb-10 lg:mb-12 max-w-xl leading-snug font-medium">
              Gestão completa via <span className="text-gray-900 font-bold">Painel Web Watch Station</span>.
              Transforme suas telas ociosas em canais de branding e vendas em 5 minutos.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12 lg:mb-16">
              <button
                onClick={handleStartFree}
                className="bg-primary text-white px-10 py-5 lg:px-12 lg:py-6 rounded-full font-black text-lg lg:text-xl flex items-center justify-center gap-3 shadow-2xl shadow-primary/30 hover:scale-[1.02] transition-all"
              >
                Começar Grátis <ArrowRight className="w-6 h-6" />
              </button>

            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-8 border-t border-gray-100 pt-8 lg:pt-10">
              {['App Mobile Nativo', 'Painel Web Desktop/Mobile', 'Suporte Técnico'].map((item, idx) => (
                <div key={idx} className="flex items-center gap-3 text-xs lg:text-sm font-bold text-gray-500 uppercase tracking-widest">
                  <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0" /> {item}
                </div>
              ))}
            </div>
          </div>

          {/* Image Carousel Side */}
          <div className="w-full lg:w-1/2 relative h-[450px] md:h-[600px] lg:h-[800px] animate-fade-in" style={{ animationDelay: '0.2s' }}>
            <div className="absolute inset-0 bg-gray-100 rounded-3xl lg:rounded-none lg:rounded-tl-[120px] overflow-hidden shadow-2xl">
              {carouselImages.map((src, index) => (
                <div
                  key={src}
                  className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${index === currentIndex ? 'opacity-100' : 'opacity-0'
                    }`}
                >
                  <img
                    src={src}
                    className="w-full h-full object-cover"
                    alt={`Preview Tela Digital ${index + 1}`}
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                </div>
              ))}
              <div className="absolute inset-0 bg-black/10 pointer-events-none"></div>

              {/* Floating Stats Card */}
              <div className="absolute bottom-6 left-6 right-6 lg:bottom-12 lg:left-12 bg-white p-6 lg:p-8 rounded-[32px] shadow-2xl flex items-center gap-6 max-w-md z-10">
                <div className="w-16 h-16 bg-gray-900 rounded-2xl flex flex-shrink-0 items-center justify-center text-primary font-black text-xl">
                  +35%
                </div>
                <div>
                  <h4 className="font-black text-gray-900 text-lg uppercase leading-none mb-1">Impacto Visual</h4>
                  <p className="text-gray-500 text-sm font-medium leading-tight">Melhore a experiência do seu cliente em tempo real.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};
